// Ensure visible on window resize
$(window).on("resize", function() {
    if ($(".form-actions.toolbar:hidden").length > 0) {
        $('.form-actions.toolbar').show();
    }
    if ($(".navbar:hidden").length > 0) {
        $('.navbar').show();
    }
});

// Hide on Scroll
$(document).on("scroll", function() {
    var width = $(window).width();
    if (width < 767) {
        if ($(".form-actions.toolbar:hidden").length == 0) {
            $('.form-actions.toolbar').hide();
        }
        var scrollA = $('body').scrollTop();
        setTimeout(function() {
            if (scrollA == $('body').scrollTop() && $(".form-actions.toolbar:hidden").length > 0) {
                $('.form-actions.toolbar').slideToggle();
            }
        }, 100);
    }
})